import { create } from 'zustand';

type State = {
  conversationId: string | null;
};

type Action = {
  setSelectedConversationId: (conversationId: string | null) => void;
};

export const useSelectedConversation = create<State & Action>()((set) => ({
  conversationId: null,
  setSelectedConversationId: (conversationId) => set(() => ({ conversationId })),
}));
